import { MultiSelect, type MultiSelectProps } from "@mantine/core";
import { useCityCatalog, usePublicCityCatalog } from "../lib/useCityCatalog";

const MAX_CITIES = 5;

type Props = Omit<MultiSelectProps, "data" | "filter" | "searchable" | "onChange" | "value" | "maxValues"> & {
  value: string[];
  onChange: (cities: string[]) => void;
  publicCatalog?: boolean;
  /** @deprecated Always flat "City - State"; kept for call-site compatibility. */
  flat?: boolean;
  maxValues?: number;
};

/**
 * Multi city picker. Flat "City - State" list; best matches float to the top.
 */
export function CityMultiSelect({
  value,
  onChange,
  publicCatalog = false,
  flat: _flat = true,
  label = "Cities",
  placeholder = "Search cities…",
  nothingFoundMessage = "No matching cities",
  maxValues = MAX_CITIES,
  ...rest
}: Props) {
  const auth = useCityCatalog(!publicCatalog);
  const pub = usePublicCityCatalog(!!publicCatalog);
  const catalog = publicCatalog ? pub : auth;

  return (
    <MultiSelect
      label={label || undefined}
      placeholder={placeholder}
      searchable
      clearable
      data={catalog.flatOptions}
      filter={catalog.filter}
      limit={50}
      value={value}
      onChange={onChange}
      maxValues={maxValues}
      nothingFoundMessage={nothingFoundMessage}
      {...rest}
    />
  );
}
